// @flow
import React from 'react';
import type { Node } from 'react';
import LazyModal from '../Common/LazyModal';
import CloseSvg from '../../svg/cancel.svg';
import Brand from './Brand';

import '../../../static/scss/components/globalModal.scss';

type Props = {
  title: string,
  isOpen: boolean,
  children: Node,
  onClose: () => void,
  hasConfirmationButton?: boolean,
  onConfirmationClick?: () => void,
  buttonCTA?: string,
  noOverflow?: boolean,
  hideClose?: boolean,
  className?: string
};

const modalBaseClassName = 'c-globalModal';

const GlobalModal = ({
  isOpen,
  onClose,
  title,
  children,
  hasConfirmationButton = false,
  onConfirmationClick = () => {},
  buttonCTA = '',
  noOverflow = false,
  hideClose = false,
  className = ''
}: Props) => (
  <LazyModal
    bodyOpenClassName={
      noOverflow
        ? `${modalBaseClassName}__body--noOverflow`
        : `${modalBaseClassName}__body`
    }
    overlayClassName={`${modalBaseClassName}__overlay`}
    className={`${modalBaseClassName}__container ${className}`}
    isOpen={isOpen}
    contentLabel={title}
    ariaHideApp={false}
  >
    <div
      className={`c-globalCheckoutError ${modalBaseClassName}__content`}
      data-cy={className}
    >
      {!hideClose && (
        <div className={`${modalBaseClassName}__close`}>
          <button
            type="button"
            className={`${modalBaseClassName}__close-icon`}
            onClick={onClose}
          >
            <CloseSvg />
          </button>
        </div>
      )}
      <h1 className={`${modalBaseClassName}__header`}>{title}</h1>

      {children}

      {hasConfirmationButton ? (
        <div className={`${modalBaseClassName}__confirm`}>
          <Brand backgroundColor>
            <button
              className="bt--primary c-globalCheckoutError__btn"
              data-cy="globalModal-confirm-button"
              type="button"
              onClick={onConfirmationClick}
            >
              {buttonCTA}
            </button>
          </Brand>
        </div>
      ) : null}
    </div>
  </LazyModal>
);

export default GlobalModal;
